// 房型预览和子景点
<template>
    <div class="abbreviation">
        <h3>{{ firstLevelIndex == 2? '推荐玩点':secondLevelIndex==0||secondLevelIndex==1?'房型预览':'菜品预览'}}</h3>
        <div class="abbreviationSlide swiper-container">
            <ul class="swiper-wrapper">
                <li
                v-for="(item,index) in scenicSpotSwiperList"
                :key="index"
                class="swiper-slide"
                >
                    <img :src="item.url">
                    <p class="price" v-if='item.price'>¥{{ item.price }}</p>
                    <h3>{{ item.title }}</h3>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import 'swiper/css/swiper.css';
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {
            scenicSpotSwiperList: []
        }
    },
    created(){
        let subSiteStr = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[this.levelThreeIndex].subSite;
        let arr = subSiteStr.replace(/\n|<div>|<\/div>/g,"").split("<br />");
        arr.forEach(item => {
            if(item.length > 10){
                let obj = {};
                obj.title = item.split("|")[0];
                obj.price = item.split("|")[1];
                obj.url = this.getImgSrc(item.split("|")[2],0);
                this.scenicSpotSwiperList.push(obj);
            }
        });
    },
    mounted(){
        const swiper = new Swiper('.abbreviationSlide',{
            slidesPerView: 'auto',
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
        });
    },
    computed: {
        ...publicData.mapState(["firstLevelIndex","allData","secondLevelIndex","levelThreeIndex"])
    },
}
</script>

<style lang="scss" scoped>
.abbreviation{
    padding-left: .4rem;
    h3{
        font-size: .36rem;
        color: #333;
    }
    .abbreviationSlide{
        height: 2.6rem;
        margin-top: .24rem;
        ul{
            display: flex;
            align-items: center;
            li{
                width: 2.4rem;
                height: 2.4rem;
                position: relative;
                border-radius: .06rem;
                overflow: hidden;
                margin-right: .26rem;
                background: #fff;
                box-shadow:0px .05rem .13rem 0px rgba(64,64,64,0.08);
                img{
                    width: 100%;
                    height: 1.58rem;
                }
                p{
                    width: auto;
                    height: auto;
                    font-size: .26rem;
                    color: #fc0;
                    position: absolute;
                    left: 0;
                    bottom: 0.82rem;
                    background: rgba(0,0,0,.6);
                    padding: .05rem .03rem;
                }
                h3{
                    font-size: .28rem;
                    color: #666;
                    padding-top: .26rem;
                    padding-left: .14rem;
                }
            }
        }
    }
}
</style>